import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import ReactPaginate from 'react-paginate';
import tr from 'date-fns/locale/tr';
import { getParlamentDecisions } from '../../api/councilService';
import { format } from 'date-fns';
import { Helmet } from 'react-helmet';

function Council() {
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [decisions, setDecisions] = useState([]);
  const itemsPerPage = 10;

  const fetchDecisions = async () => {
    try {
      setLoading(true);
      const response = await getParlamentDecisions(
        currentPage + 1,
        itemsPerPage,
        searchTerm,
        startDate,
        endDate
      );
      if (response.isSuccess) {
        setDecisions(response.data.items.map(item => ({
          id: item.guid,
          date: format(new Date(item.date), 'dd.MM.yyyy'),
          decisionNumber: item.decisionsNo || '-',
          summary: item.header,
          urlTag: item.urlTag
        })));
      }
    } catch (err) {
      setError('Kararlar yüklenirken bir hata oluştu');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDecisions();
  }, [currentPage, searchTerm, startDate, endDate]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(0);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Link to={`/meclis-kararlari/${rowData.urlTag}`} state={{ guid: rowData.id }} className="btn btn-primary btn-sm">
        Detaya Git
      </Link>
    );
  };

  // Sayfalama için veri dilimi
  const pageCount = Math.ceil(decisions.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className="council-decisions">
       <Helmet>
        <title>Meclis Kararları | İskenderun Belediyesi</title>
        <meta name="description" content="İskenderun Belediyesi meclis kararlarılistesi." />
      </Helmet>
     
        <h1>Meclis Kararları</h1>

        <div className="news-tabs-filter">
          <div className="news-tabs-filter-left">
            <div className="news-tabs-filter-left-item">
              <input 
                type="text" 
                placeholder="Kararlarda Ara" 
                value={searchTerm}
                onChange={handleSearch}
              />
              <i className="pi pi-search"></i>
            </div>
          </div>
          <div className="news-tabs-filter-right">
            <div className="news-tabs-filter-right-item">
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                locale={tr}
                className="form-control"
                placeholderText="Tarih Aralığı"
                dateFormat="dd.MM.yyyy"
                isClearable
              />
              <i className="pi pi-calendar"></i>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : (
          <>
            <DataTable value={decisions} className="council-table">
              <Column field="date" header="Tarih" style={{ width: '15%' }}></Column>
              <Column field="decisionNumber" header="Karar No" style={{ width: '15%' }}></Column>
              <Column field="summary" header="Karar Özeti" style={{ width: '55%' }}></Column>
              <Column body={actionBodyTemplate} header="" style={{ width: '15%' }}></Column>
            </DataTable>

            <ReactPaginate
              previousLabel="<"
              nextLabel=">"
              breakLabel="..."
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName="pagination"
              activeClassName="active"
            />
          </>
        )}
   
    </div>
  );
}

export default Council;
